import global from '../general/global';

export default function () {
    let imageSwiper, contentSwiper;

    if (!global.swiperLoaded) {
        loadjs([menaObject.assets + '/js/swiper.min.js', menaObject.assets + '/css/swiper.css'], function () {
            imageSwiper = new Swiper('.js-staff--image-swiper', {
                slidesPerView: 3,
                centeredSlides: true,
                spaceBetween: 16,
                allowTouchMove: false,
                slideToClickedSlide: true,
                touchRatio: 0,
                loop: true,
                breakpoints: {
                    768: {
                        slidesPerView: 5,
                    },
                },
            });

            contentSwiper = new Swiper('.js-staff--content-swiper', {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 16,
                allowTouchMove: false,
                slideToClickedSlide: true,
                touchRatio: 0,
                loop: true,
            });

            global.swiperLoaded = true;

            imageSwiper.on('click', function (swiper, event) {
                let slideIndex = Number(event.path[1].getAttribute('data-swiper-slide-index'));

                contentSwiper.slideTo(slideIndex + 1, 0);
            });
        });
    } else {
        imageSwiper = new Swiper('.js-staff--image-swiper', {
            slidesPerView: 5,
            centeredSlides: true,
        });

        contentSwiper = new Swiper('.js-staff--content-swiper', {
            slidesPerView: 1,
        });
    }
}
